import { useEffect, useRef } from 'react'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'

const NOTIFICATIONS_QUERY_KEY = ['notifications'] as const

export const markNotificationForNotifiable = async (type: string, id: string) => {
  await AXIOS_INSTANCE.patch('notifications/mark_read_by_notifiable', {
    notifiable_type: type,
    notifiable_id: id
  })
  queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_QUERY_KEY })
}

/**
 * When a detail page mounts with a concrete notifiable id, mark matching
 * notifications read (and clear siblings for the same event on the server).
 */
export const useMarkNotificationForNotifiable = (type?: string | null, id?: string | null) => {
  const markedKey = useRef<string | null>(null)

  useEffect(() => {
    if (!type || !id) return
    const key = `${type}:${id}`
    if (markedKey.current === key) return
    markedKey.current = key
    markNotificationForNotifiable(type, id).catch(() => {
      markedKey.current = null
    })
  }, [type, id])
}
